// Max length of action type name is 64 symbols (database column config)
export enum LogActionType {
  NewUser = 'NewUser',
  NewSession = 'NewSession',
  NewHit = 'NewHit',

  LogoClick = 'LogoClick',

  FeatureRequest = 'FeatureRequest',
  FeatureRequestButtonClick = 'FeatureRequestButtonClick',
  FeatureRequestModalOpen = 'FeatureRequestModalOpen',
  FeatureRequestModalClose = 'FeatureRequestModalClose',

  LandingSelectFileButtonClick = 'LandingSelectFileButtonClick',
  LandingTestFileButtonClick = 'LandingTestFileButtonClick',

  ImportBlob = 'ImportBlob',
  ImportSuccess = 'ImportSuccess',
  ImportFail = 'ImportFail',

  UploadChooseFileButtonClick = 'UploadChooseFileButtonClick',
  UploadFileSelected = 'UploadFileSelected',
  UploadFileDecoded = 'UploadFileDecoded',
  UploadDecodingError = 'UploadDecodingError',
  UploadDragStart = 'UploadDragStart',
  UploadDragEnd = 'UploadDragEnd',
  UploadDragFileDrop = 'UploadDragFileDrop',

  HotkeyPress = 'HotkeyPress',
  ToolbarButtonClick = 'ToolbarButtonClick',

  DownloadFormatClick = 'DownloadFormatClick',
  DownloadBitrateClick = 'DownloadBitrateClick',
  DownloadChannelsClick = 'DownloadChannelsClick',
  DownloadFilenameChange = 'DownloadFilenameChange',
  DownloadButtonClick = 'DownloadButtonClick',
  DownloadBufferRendered = 'DownloadBufferRendered',
  DownloadWavEncoded = 'DownloadWavEncoded',
  DownloadFfmpegLoaded = 'DownloadFfmpegLoaded',
  DownloadFileConverted = 'DownloadFileConverted',
  DownloadCompilationError = 'DownloadCompilationError',
  DownloadFileDownloadingError = 'DownloadFileDownloadingError',
  DownloadFileDownloaded = 'DownloadFileDownloaded',

  PlaybackPlayButtonClick = 'PlaybackPlayButtonClick',
  PlaybackPauseButtonClick = 'PlaybackPauseButtonClick',
  PlaybackPlayHotkeyPress = 'PlaybackPlayHotkeyPress',
  PlaybackPauseHotkeyPress = 'PlaybackPauseHotkeyPress',
  PlaybackStopButtonClick = 'PlaybackStopButtonClick',
  PlaybackVolumeChange = 'PlaybackVolumeChange',
  PlaybackVolumeMute = 'PlaybackVolumeMute',
  PlaybackVolumeUnmute = 'PlaybackVolumeUnmute',

  ChannelsPlayButtonClick = 'ChannelsPlayButtonClick',
  ChannelsStopButtonClick = 'ChannelsStopButtonClick',
  ChannelsSelectionHandleChange = 'ChannelsSelectionHandleChange',

  TimelineSelectionChange = 'TimelineSelectionChange',
}
